import React, { Ref } from "react";
import * as Type from "@interface/index";
import Clickoutside from "@helpers/Clickoutside";
import * as Middleware from "@middlewares/index";
import Connector from "@helpers/Connector";

interface PropsInterface extends Type.ComponentInterface {
  name: string;
  value: any[];
  required?: boolean;
  disabled?: boolean;
  onChange?: (field: string, value: string[]) => void;
}

interface StateInterface {
  show: boolean;
  value: any[];
}

export default Connector(
  class InputCompanyTypeForRegistration extends React.Component<
    PropsInterface,
    StateInterface
  > {
    public constructor(props: PropsInterface) {
      super(props);
      this.state = {
        show: false,
        value: this.props.value || [],
      };
    }

    public componentDidMount() {
      Middleware.Company.Type.load();
    }

    public componentDidUpdate(props: PropsInterface) {
      if (this.props.value !== props.value) {
        const value = this.props.value;
        value.sort((a, b) => a - b);
        this.setState({ value });
      }
    }

    private handleCheckboxChange = (itemId: any) => {
      const { value } = this.state;
      const newValue = value.includes(itemId)
        ? value.filter((id) => id !== itemId)
        : [...value, itemId];

      this.setState({ value: newValue });

      if (this.props.onChange) {
        this.props.onChange("typeCompany", newValue);
      }
    };

    private renderItems(Group: any) {
      const items: JSX.Element[] = [];
      Group.itemList.map((Item: any, index: number) => {
        items.push(
          <div className="auth__dropdown-item" key={index}>
            <input
              tabIndex={0}
              className="visually-hidden"
              type="checkbox"
              name={this.props.name}
              id={Item.id}
              value={Item.id}
              checked={this.state.value.includes(Item.id)}
              onChange={() => this.handleCheckboxChange(Item.id)}
            />
            <label htmlFor={Item.id}>{Item.name}</label>
          </div>
        );
      });
      return items;
    }

    public render() {
      return (
        <>
          <Clickoutside clickOutside={() => this.setState({ show: false })}>
            <label className="visually-hidden" htmlFor="companytype">
              Тип компании
            </label>

            <div
              className={`input-dd ${
                !this.state.show ? "input-dd--close" : ""
              }`}
            >
              <label
                htmlFor="companyType"
                className={`input-dd__trigger
                 ${this.props.disabled ? "disabled" : ""}
                 ${
                   this.props.required &&
                   this.state.value.length === 0 &&
                   "required-input"
                 }`}
                onClick={() => {
                  if (!this.props.disabled) {
                    this.setState({ show: !this.state.show });
                  }
                }}
              >
                <input
                  type="text"
                  name="companyTypeCustomInput"
                  id="companyTypeCustomInput"
                  value={this.state.value.join()}
                  className="visually-hidden"
                  required={this.props.required}
                  onChange={(e) => {
                    const newValue = e.target.value.split(",");
                    this.setState({ value: newValue });
                  }}
                  onFocus={() => this.setState({ show: true })}
                  style={{
                    width: "100% !important",
                    height: "2.5em !important",
                  }}
                />
                <span className="input-dd__trigger-placeholder">
                  &nbsp;Тип компании:&nbsp;
                </span>{" "}
                {this.props.Store.Company.Type?.list
                  .filter((Type) => this.state.value.includes(Type.id))
                  .map((Type: any, index: number) => {
                    return (
                      <span className="input-dd__trigger-picked" key={Type.id}>
                        {(index !== 0 ? ", " : "") + Type.name}
                      </span>
                    );
                  })}
              </label>
              <div className="input-dd__main">
                {this.props.Store.Company.Type?.groups.map(
                  (Group: any, index: number) => {
                    if (Group.id !== 0) {
                      return (
                        <div className="auth__dropdown-group" key={index}>
                          <div className="auth__dropdown-group-title">
                            {Group.name}
                          </div>
                          {this.renderItems(Group)}
                        </div>
                      );
                    } else {
                      return this.renderItems(Group);
                    }
                  }
                )}
              </div>
            </div>
          </Clickoutside>
        </>
      );
    }
  }
);
